import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { isAuthenticated } from '../../../../services/auth';
import {
  message,
  Popconfirm,
  Pagination,
} from 'antd';
import { addCategory, allCategories, deleteCategory } from '../../../../services/category';
import moment from 'moment';
import throttle from 'lodash/throttle';
import UnifiedDashboard from '../../../../components/layout/UnifiedDashboard';
import './AddCategory.css';

const AddCategory = () => {
  const [name, setName] = useState('');
  const countPerPage = 5;
  const [categories, setCategories] = useState({
    category: [],
    pagination: [],
    deleted: false,
    newAdded: false,
  });
  const [current, setCurrent] = useState();
  const [search, setSearch] = useState('');
  const { category, pagination, deleted, newAdded } = categories;

  const { token } = isAuthenticated();

  const searchData = useRef(
    throttle(async (val) => {
      const query = val.toLowerCase();
      setCurrent(1);
      const data = await allCategories();
      const newData = data.data
        .filter((item) => item.name.toLowerCase().indexOf(query) > -1)
        .slice(0, countPerPage);
      setCategories({ ...categories, pagination: newData });
    }, 400)
  );

  useEffect(() => {
    if (!search) {
      loadCategories(1);
    } else {
      searchData.current(search);
    }
  }, [search, newAdded, deleted]);

  const loadCategories = async (page) => {
    const res = await allCategories();
    setCurrent(page);
    const to = page * countPerPage;
    const from = to - countPerPage;
    setCategories({ category: res.data, pagination: res.data.slice(from, to) });
  };

  const handleDelete = async (categoryId) => {
    const res = await deleteCategory(categoryId, token);
    if (res.error) {
      console.log(res.error);
    } else {
      console.log(res);
      message.success('Categoria excluída', 4);
      setCategories({ ...categories, deleted: true });
    }
  };

  const handleChange = (e) => {
    setName(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await addCategory({ name });
      console.log(res);
      message.success('Categoria adicionada', 4);
      setName('');
      setCategories({ ...categories, newAdded: true });
    } catch (err) {
      console.log(err);
      if (err.response.status === 400) message.error(err.response.data, 4);
    }
  };

  return (
    <UnifiedDashboard title="Adicionar Categoria">
      <div className='add-category-container'>
        {/* Header Section */}
        <div className='add-category-header'>
          <div className='add-category-header-content'>
            <h2 className='add-category-title'>
              <i className='fas fa-tag'></i>
              Adicionar Categoria
            </h2>
            <p className='add-category-subtitle'>Crie uma nova categoria para o sistema</p>
          </div>
        </div>

        {/* Form Card */}
        <div className="add-category-form-card">
          <div className="add-category-form-wrapper">
            <form onSubmit={handleSubmit}>
              <div className="add-category-form-group">
                <label className="add-category-label">
                  <i className="fas fa-tag me-2"></i>
                  Nome da Categoria
                </label>
                <input
                  type='text'
                  className='add-category-input'
                  placeholder='Digite o nome da categoria (ex: Eletrônicos)'
                  value={name}
                  onChange={handleChange}
                  required
                />
              </div>
              <button
                type="submit"
                className="add-category-submit-btn"
              >
                <i className="fas fa-plus me-2"></i>
                Adicionar Categoria
              </button>
            </form>
          </div>
        </div>

        {/* List Card */}
        <div className="add-category-list-card">
          <div className="add-category-list-header">
            <h3 className="add-category-list-title">
              <i className="fas fa-list"></i>
              Categorias Registradas
            </h3>
            <div className="add-category-search-wrapper">
              <i className="fas fa-search add-category-search-icon"></i>
              <input
                type='text'
                className='add-category-search-input'
                placeholder='Buscar categorias...'
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="add-category-list-body">
            {pagination && pagination.length > 0 ? (
              <>
                <div className="add-category-table-wrapper">
                  <table className='add-category-table'>
                    <thead>
                      <tr>
                        <th>
                          <i className="fas fa-tag me-2"></i>
                          Nome
                        </th>
                        <th>
                          <i className="fas fa-calendar me-2"></i>
                          Data de Adição
                        </th>
                        <th className="text-center">
                          <i className="fas fa-cogs me-2"></i>
                          Ações
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {pagination.map((c, i) => (
                        <tr key={i}>
                          <td>
                            <Link
                              to={`/category/${c._id}`}
                              className='text-decoration-none fw-medium add-category-table-link'
                            >
                              <i className="fas fa-folder me-2"></i>
                              {c.name}
                            </Link>
                          </td>
                          <td className="add-category-table-date">
                            <i className="fas fa-clock me-2"></i>
                            {moment(c.createdAt).format('DD/MM/YYYY')}
                          </td>
                          <td className="add-category-table-actions">
                            <Link
                              to={`/admin/category/edit/${c._id}`}
                              className='add-category-btn add-category-btn-edit'
                            >
                              <i className="fas fa-edit me-1"></i>
                              Editar
                            </Link>
                            <Popconfirm
                              placement='top'
                              title='Tem certeza que deseja excluir esta categoria?'
                              onConfirm={() => handleDelete(c._id)}
                              okText='Sim'
                              cancelText='Não'
                            >
                              <button className='add-category-btn add-category-btn-delete'>
                                <i className="fas fa-trash me-1"></i>
                                Excluir
                              </button>
                            </Popconfirm>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="add-category-pagination">
                  <Pagination
                    pageSize={countPerPage}
                    onChange={loadCategories}
                    defaultCurrent={current}
                    total={category.length}
                    showSizeChanger={false}
                    showQuickJumper
                    showTotal={(total, range) => 
                      `${range[0]}-${range[1]} de ${total} categorias`
                    }
                  />
                </div>
              </>
            ) : (
              <div className="add-category-empty-state">
                <i className="fas fa-inbox"></i>
                <h5>Nenhuma categoria encontrada</h5>
                <p>
                  {search ? 'Tente buscar com outros termos' : 'Adicione sua primeira categoria acima'}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </UnifiedDashboard>
  );
};

export default AddCategory;